/* globals jQuery */
/*
*  jquery.FreeLoader.js
*              ___    \/)'/
*        _____|| ||_____ (o//\    *BEEP BOOP*
*        | o  |___|  o |\o)/
*        |   [(===)]   |)
*        |_____| |_____|
*   ___  ____//\_/\\____  ___
*  |   | |_|___\_/___|_| |   |
* [|   |]| |===      | |[|   |]
*  |___| |_|o_______o|_| |___|
*   \ |    \|_______|/    | /
*  _|_|_    [__|_|__]    _|_|_
*  |___|      |___|      |___|
*  |   |       | |       |   |
*             [| |]
*/

/**
* jQuery plugin that ensures (image) elements are loaded
*  @version 0.1.1
*  @author Aric Ng

* Changelog
* 0.1.1
* - Changed image load to use data-src instead of looking via jQuery.data('src') this caused original images to load instead
* - Formatting updates
*/

/* global console: true, window: true, document: true */
/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/

/**
 * The jQuery plugin namespace.
 * @external "jQuery.fn"
 * @see {@link http://docs.jquery.com/Plugins/Authoring The jQuery Plugin Guide}
 */


/**
* @name FreeLoader
* @description Encapsulates jQuery.FreeLoader plugin functionality
* @returns {undefined} This function doesn't return anything
*/
jQuery.FreeLoader = (function FreeLoader() {

  'use strict';

  var $ = jQuery;

  /**
  * @function completePath
  * @description Normalizes a given url into a full (absolute) path with the given document url
  * @param {string} url url to normalize
  * @param {string} urlDocument Generally a base document URL via window.location.href
  * @returns {string} a normalized URL
  */
  function completePath(url, urlDocument) {

    var path = [];
    var dirTraversal = [];
    var a = document.createElement('a');
    var i = 0;

    // Validate Input
    if (typeof url !== 'string') {
      return false;
    }
    if (typeof urlDocument !== 'string') {
      return false;
    }

    a.href = urlDocument;

    // Full Path
    if (url.charAt(0) === '/') {
      return a.protocol + '//' + a.hostname + url;
    }

    // Absolute path
    if (url.indexOf('://') !== -1) {
      return url;
    }

    // Relative Path
    path = a.pathname.split('/');

    // Remove document from path
    if (path[path.length - 1] !== '') {
      path[path.length - 1] = '';
    }
    path.pop();

    // Directory depth
    dirTraversal = url.match(/\.\.\//g);
    if (typeof dirTraversal === 'object' && dirTraversal !== null) {

      // Traverse up
      for (i = 0; i < dirTraversal.length; i++) {

        if (dirTraversal[i] === '../') {
          path.pop();
        }

      }
      url = url.replace(/\.\.\//g, '');

    }

    return a.protocol + '//' + a.hostname + path.join('/') + '/' + url;

  }

  /**
  * @function getImages
  * @description Get data-src and adds it into imagePaths
  * @param {jQuery} $selector Selector to find image paths from img and .preload class elements from
  * @param {Array} arr Array that will contain imagePaths found
  * @param {boolean} loadHidden Whether to load hidden images or not
  * @returns {undefined} This function does not return anything
  */
  function getImages($selector, arr, loadHidden) {

    /* jshint validthis:true */
    var $this = $selector;

    loadHidden = typeof loadHidden === 'undefined' ? true : loadHidden;

    $this.each(function() {

      var $this = $(this);
      var imagePath = $this.data('src');
      var fullPath;

      if (!loadHidden && !$this.is(':visible')) {
        return;
      }

      if (typeof imagePath === 'undefined' || imagePath.length === 0) {
        return;
      }
      
      fullPath = completePath(imagePath, window.location.href);
      $this.data('src', fullPath);
      // Do not allow elements with ignoreTargets to be preloaded
      // if ($this.is(options.ignoreTargets)) return;

      // Handle this outside of script
      // Append options.imagePath to imagePath found in data src
      // if (typeof options.imagePath !== 'undefined' && options.trim(options.imagePath).length !== 0)
        // imagePath = options.imagePath+imagePath;

      // Push only if there are no duplicate paths
      if (arr.indexOf(fullPath) === -1) {
        arr.push(fullPath);
      }

    });

    // $preloadImages = $preloadImages.add($this);

  }

  /**
  * @class Loader
  * @description Loader object to encapsulate loading for a group of selectors with images to load
  * @param {object} targetImages Selectors w/ imagePaths to load
  * @param {object} options Various options to tweak loader functionality
  *  @param {function} callback [options.callback=function() {}] Function to call when load is complete
  *  @param {number} imageTimeout [options.imageTimeout: 2000] Timeout before image load is aborted per individual image
  *  @param {number} loadTimeout [options.loadTimeout: 8000] Timeout per loader before complete is forcibly called, default to 8 seconds
  *  @param {boolean} debug [option.debug=false] Whether to show debug messages or not
  *  @param {Number} imageStep [option.imageStep = 0] Amount of images to load at a time, default is set to 0, all images per target are loaded.
  *  @param {function} onImageLoad [options.onImageLoad=undefined] Callback for when an image loads
  * @returns {undefined} undefined This function does not return anything
  */
  function Loader(targetImages, options) {

    var defaults = {
      callback: function() {},
      imageTimeout: 2000,
      loadTimeout: 8000,
      imageStep: 0,
      onImageLoad: undefined
    };
    var t = 0;

    this.options = $.extend(defaults, options);
    this.callback = this.options.callback;
    this.targetImages = targetImages;
    this.loadTimeout = this.options.loadTimeout;
    this.imageTimeout = this.options.imageTimeout;
    this.debug = this.options.debug;
    this.imageStep = this.options.imageStep;

    // Keeps track of images loaded on top of images to load
    // Resets each time a new target is reached
    this.imagesLoaded = 0;
    this.imagesToLoad = 0;

    this.imagesLoadedInStep = 0;

    /*
      Preload state representing what state the loader is in
      -1: Not started
      0: In progress
      1: complete
    */
    this.state = -1;

    // Save $targets for load complete (set src attribute with image paths) after all imagePaths have been loaded
    this.$targets = $();
    for (t = 0; t < targetImages.length; t++) {

      this.$targets = this.$targets.add(targetImages[t].$target);

    }

    // If there are no targetImages, complete preloading immediately
    if (targetImages.length === 0)
    {
      if (this.debug) {
        console.log('jquery.FreeLoader.js: Loader: No images to load: Completing');
      }
      
      this.complete();
      return;
    }

    // Begin preload of target set of images immediately
    this.nextTarget();

  }

  Loader.prototype = {

    /**
    * @function updateTimeout
    * @description Sets the load timeout before complete() is called on this loader instance. Will clear and recreate timeout if it exists.
    * @returns {undefined} undefined This function does not return anything
    */
    updateTimeout: function() {

      var _this = this;

      if (this.loadTimeout <= 0) {
        return;
      }

      if (this.debug) {
        console.log('FPFreeLoader: updateTimeout: ' + (typeof this.loaderTimeout === 'undefined' ? 'Created timeout' : 'Recreating timeout') + ' with timeout of ' + this.loadTimeout);
      }
      
      window.clearTimeout(this.loaderTimeout);
      this.loaderTimeout = window.setTimeout(function() {

        if (_this.debug) {
          console.error('FreeLoader: Timeout Fired');
        }
        
        _this.complete();

      }, this.loadTimeout);

    },

    /**
    * @function loadImage
    * @description Loads specified image path, function scope prevents image load/error event and timeout overlap.
    * @param {string} imagePath Image path to load
    * @returns {undefined} undefined This function does not return anything
    */
    loadImage: function(imagePath) {

      var image = new Image();
      var timeout;
      var _this = this;

      // Do not allow loading if the loader has completed or has complete forced
      if (this.state === 1) {
        return;
      }

      image.onload = function() {

        window.clearTimeout(timeout);
        _this.onLoadHandler(image);

      };
      image.onerror = function() {

        window.clearTimeout(timeout);
        _this.onErrorHandler(image);

      };
      image.src = imagePath;

      // Abort image load if it has been loaded from cache
      if (image.complete) {

        if (this.debug) console.error('FreeLoader: Loader: Image load aborted: Already in cache ' + imagePath);
        window.clearTimeout(timeout);
        this.onLoadHandler(image);
        image.src = '';

      }

      // Abort image load if it takes too long
      timeout = window.setTimeout(function() {

        if (this.debug) {
          console.error('FreeLoader: Loader: Image load aborted: Image took too long to load ' + imagePath + ' ' + _this.imageTimeout + 'ms');
        }
        
        image.src = '';

      }, _this.imageTimeout);

    },

    /**
    * @function next
    * @description Loads the next set of of imagePaths from this.targetImages, otherwise if there are no more targetImage, call complete
    * @returns {undefined} undefined This function does not return anything
    */
    nextTarget: function() {

      var imagePaths;
      var $target;

      // Push up timeout whenever this is called
      this.updateTimeout();

      // If there are no more target Images to load, assume preloading has completed
      if (this.targetImages.length === 0) {

        this.complete();

        return;

      }

      // Do not allow loading if the loader has completed or has complete forced
      if (this.state === 1) {
        return;
      }

      // Mark this loader as in progress
      this.state = 0;

      // Used to keep track of current target and image paths
      this.currentTarget = this.targetImages.pop();

      $target = this.currentTarget.$target;
      imagePaths = this.currentTarget.imagePaths;

      // Set imagesLoaded and imagesToLoad for this set of imagePaths
      this.imagesLoaded = 0;
      this.imagesToLoad = imagePaths.length;

      if (this.debug) {
        console.info('FreeLoader: Loader: Loading images in: ', $target, ' with ' + imagePaths.length + ' images');
      }
      
      this.nextImagePath();

    },

    /**
    * @function nextImagePath
    * @description Gets the next set of images to load if imageStep is set, otherwise load all images
    * @returns {undefined} undefined This function does not return anything
    */
    nextImagePath: function () {

      var  imagePaths;
      var imageCount = 0;

      // Reset imagesLoadedInStep per step
      this.imagesLoadedInStep = 0;

      imagePaths = this.currentTarget.imagePaths;

      if (this.imagesLoaded === 0 && this.debug) {
        console.info('FreeLoader: Loader: Loading ' + (this.imageStep === 0 ? 'all images at once' : this.imageStep + ' at a time'));
      }
      
      /*
      // Load images from image paths
      for (i = 0; i < imagePaths.length; i++) {

        // Do not allow loading if the loader has completed or has complete forced
        if (this.state === 1)
          return;

        this.loadImage(imagePaths[i]);

      }
      */

      // Load all images at once if imageStep is 0, otherwise load up to imageStep amount; and while there are more imagePaths to load.
      while ((this.imageStep === 0 ? true : imageCount < this.imageStep) && imagePaths.length !== 0) {

        this.loadImage(imagePaths.shift());
        imageCount++;

      }

    },

    /**
    * @function complete
    * @description Handles completion of imagePath loading done on nextTarget(), this function can be used to manually stop load. Sets src attribute with path found in data-src, if .preload class, sets background-image to url containing path.
    * @returns {undefined} undefined This function does not return anything
    */
    complete: function() {

      // Do not allow complete to be called more than once
      if (this.state === 1) {
        return;
      }

      if (this.debug) {
        console.info('FreeLoader: Complete');
      }

      // Prevent complete from being called more than once
      window.clearTimeout(this.loaderTimeout);

      // Mark this loader as complete
      this.state = 1;

      // Set src attr for $targets to path specified in data-src attribute, then remove data-src to avoid any later confusion
      this.$targets.each(function() {

        var $this = $(this),
        dataSrc = $this.attr('data-src');

        //$this.removeData('src');
        if (typeof dataSrc !== 'undefined') {
          if ($this.is('.FreeLoader')) {
            $this.css({backgroundImage: 'url(' + dataSrc + ')'});
          } else {
            $this.attr('src', dataSrc);
          }
        }

      });

      // Run callback
      this.callback();

    },

    /**
    * @function onLoadHandler
    * @description Tracks and progresses loader, if the amount of images loaded matches images to load, nextTarget() is called to load the next set of imagePaths
    * @param {Image} image Image that loaded
    * @returns {undefined} undefined This function does not return anything
    */
    onLoadHandler: function(image) {

      // Do not allow progression if the loader has completed or has complete forced
      if (this.state === 1) {
        return;
      }

      /* jshint validthis:true */
      if (this.debug) {
        console.log('FreeLoader: Loaded ' + image.src + ' ' + (this.imagesLoaded + 1) + ' out of ' + this.imagesToLoad);
      }
      
      this.imagesLoaded++;
      this.imagesLoadedInStep++;

      // If all images per target have been loaded, load next set of images
      if (this.imagesLoaded >= this.imagesToLoad) {

        this.nextTarget();

        return;

      } else if (this.imagesLoadedInStep >= this.imageStep) {
        this.nextImagePath();
      }

      // Trigger callback for image load
      if (typeof this.options.onImageLoad === 'function') {
        this.options.onImageLoad(image, this.imagesLoaded, this.imagesToLoad);
      }

    },

    /**
    * @function onErrorHandler
    * @description Functionally the same as onLoadHandler; if debug is enabled, tracks images that fail to load
    * @param {Image} image Image that failed to load
    * @returns {undefined} undefined This function does not return anything
    */
    onErrorHandler: function(image) {

      // Do not allow progression if the loader has completed or has complete forced
      if (this.state === 1) {
        return;
      }

      /* jshint validthis:true */
      if (this.debug) {
        console.log('FreeLoader: Failed to load ' + image.src + ' ' + (this.imagesLoaded + 1) + ' out of ' + this.imagesToLoad);
      }
      
      this.onLoadHandler(image);

    }

  };

  /**
  * @function external:"jQuery.fn".FreeLoader
  * @description jQuery plugin for LazyLoading functionality. Elements that want to use this functionality must have a data-src with image path set. By default this preloader looks for img elements, but will also look for non-img elements with the FreeLoader class.
  * @param {options} options to pass into a Loader instance to modify functionality
  *  @param {boolean} loadHidden [option.loadHidden=true] If loadHidden true all images are loaded, otherwise images that are not visible
  *  @param {number} imageTimeout [option.imageTimeout=2000] imageTimeout Timeout before image load is aborted per individual image
  *  @param {number} loadTimeout [option.imageTimeout=8000] loadTimeout [options.loadTimeout: 8000] Timeout per loader before complete is forcibly called, default to 8 seconds
  *  @param {boolean} debug [option.debug=false] Whether to show debug messages or not
  * @returns {Loader|jQuery} Returns either a newly created Loader instance or the selector used to call this function
  */
  jQuery.fn.FreeLoader = function(options) {

    var targetImages = [];
    var  $images;
    var  $preloadTargets;
    var  defaults = {
        loadHidden: true,
        imageTimeout: 2000, // Timeout per individual timeout
        loadTimeout: 8000, // Timeout per loader
        debug: false,
        onImageLoad: undefined
        // callback;
      };
    var  loadHidden;
    var  imagePaths;
    var  loader;

    options = $.extend(defaults, options);
    loadHidden = options.loadHidden;

    // Get all images and preload classed targets from selector
    $(this).each(function() {

      var $this = $(this);

      $images = $this.find('img').addBack('img'); // For when it itself is an image
      $preloadTargets = $this.find('.FreeLoader').addBack('.FreeLoader');

      imagePaths = [];

      getImages($images, imagePaths, loadHidden);
      getImages($preloadTargets, imagePaths, loadHidden);

      if (imagePaths.length !== 0) {

        // First in first out
        targetImages.unshift({
          $target: $images.add($preloadTargets),
          imagePaths: imagePaths
        });

      }

    });

    if (options.debug) {
      console.log('FreeLoader: Found: ' + targetImages.length + targetImages);
    }

    loader = new Loader(targetImages, options);

    return typeof loader === 'undefined' ? $(this) : loader;

  };

}());